import React, { FC } from 'react'
import { Box, Typography, makeStyles } from '@material-ui/core'
import { Link, generatePath } from 'react-router-dom'
import HighlightedText from 'UI/HighlightedText'
import { KB_VIEW_URL } from 'constants/routes'
import { IArticleSearchResult } from 'typescript/interfaces/knowledgeBase'

interface IKnowledgeBaseSearchResults {
  results: Array<IArticleSearchResult>
  search: string
}

const useStyles = makeStyles((theme) => ({
  row: {
    display: 'block',
    padding: '1rem 1.25rem',
    marginBottom: '0.75rem',
    borderRadius: '8px',
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.common.white,
    textDecoration: 'none',
    transition: 'border-color 0.2s',
    '&:hover': {
      borderColor: theme.palette.secondary.main,
    },
  },
  title: {
    color: theme.palette.text.secondary,
  },
  section: {
    color: theme.palette.text.disabled,
  },
  snippet: {
    marginTop: '0.4rem',
    color: theme.palette.text.primary,
  },
}))

const KnowledgeBaseSearchResults: FC<IKnowledgeBaseSearchResults> = ({ results, search }) => {
  const s = useStyles()

  return (
    <Box>
      {results.map((result) => (
        <Box key={result.id} component={Link} to={generatePath(KB_VIEW_URL, { id: result.id })} className={s.row}>
          <Box display="flex" alignItems="baseline" justifyContent="space-between">
            <Typography variant="h4" className={s.title}>
              <HighlightedText text={result.title} search={search} />
            </Typography>
            <Typography variant="caption" className={s.section}>
              {result.sectionName}
            </Typography>
          </Box>
          {!!result.snippet && (
            <Typography variant="body2" className={s.snippet}>
              <HighlightedText text={result.snippet} search={search} />
            </Typography>
          )}
        </Box>
      ))}
    </Box>
  )
}

export default KnowledgeBaseSearchResults
